<script>
    export let title;
    export let value;
    export let description;
</script>

<div class="report-attribute">
    <div class="report-attribute-title">{title}</div>
    <div class="report-attribute-value">{value}</div>
    {#if description}
        <div class="report-attribute-description">{description}</div>
    {/if}
</div>
